
export interface CreditLink {
    text: string;
    url: string;
}

export interface CreditProject {
    title: string;
    director: string;
    details: string;
    role: string;
    links?: CreditLink[];
    note?: string;
}

export interface CreditYear {
    year: string;
    projects: CreditProject[];
}

export const creditsData: CreditYear[] = [
    {
        "year": "Ongoing Projects",
        "projects": [
            {
                "title": "ScreenME Podcast",
                "director": "Ulrike Rohn.",
                "details": "(Podcast, Estonia).",
                "role": "Podcast Recordist and Editor",
                "links": [
                    {
                        "url": "https://open.spotify.com/show/20gDh8w3gVeFFD0N9fjs1i",
                        "text": "Listen on Spotify"
                    }
                ],
                "note": "(2024 - present)"
            }
        ]
    },

    {
        "year": "2026",
        "projects": [
            {
                "title": "Humans Remain",
                "director": "Dirk Hoyer",
                "details": "(Documentary, Feature, Italy)",
                "role": "Sound Designer",
                "note": "Dolby Atmos Project 🔊"
            }
        ]
    },
    {
        "year": "2025",
        "projects": [
            {
                "title": "Stop the Car",
                "director": "Igor Hristov",
                "details": "(Fiction, Short, Bulgaria)",
                "role": "Sound Mixing Engineer (Stereo to 5.1 Upmix)"
            },
            {
                "title": "Kuidas Leppida Ööga",
                "director": "Maria Paiste",
                "details": "(Fiction, Short, Estonia)",
                "role": "Sound Designer"
            },
            {
                "title": "Manse",
                "director": "Felix Cognard.",
                "details": "(Fiction, Short, France)",
                "role": "Sound Recordist, Sound Designer",
                "note": "Dolby Atmos Project 🔊"
            },
            {
                "title": "Beaux Soleils (Working Title)",
                "director": "Lou-Andréa Fiere.",
                "details": "(Fiction, Short, France)",
                "role": "Sound Recordist"
            },
            {
                "title": "Singing of the Evening Stars",
                "director": "Iris Sang.",
                "details": "(Documentary, Short, USA)",
                "role": "Sound Designer",
                "note": "Dolby Atmos Project 🔊"
            },
            {
                "title": "Chronotopes of Nostalgia",
                "director": "Diego Barajas.",
                "details": "(Fiction, Short, Estonia)",
                "role": "Sound Recordist"
            },
            {
                "title": "Time Paradox",
                "director": "Minha Park",
                "details": "(Documentary, Short, USA).",
                "role": "Sound Designer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt35932806/",
                        "text": "IMdb"
                    },
                    {
                        "url": "https://cphdox.dk/film/time-paradox/",
                        "text": "CPH:DOX 2025"
                    }
                ]
            },
            {
                "title": "Threads",
                "director": "Michael Dawson.",
                "details": "(Short, Estonia).",
                "role": "Sound Recordist"
            },
            {
                "title": "Jar of Time",
                "director": "Nevena Semova.",
                "details": "(Documentary, Short, Bulgaria)",
                "role": "Sound Designer",
                "note": "Best Documentary winner, 2025, In The Palace - International Film Festival",
                "links": [
                    {
                        "text": "Teaser",
                        "url": "https://vimeo.com/907640035/1f91f2dbf9?share=copy"
                    },
                    {
                        "text": "Pitch Deck",
                        "url": "https://attic-films.com/wp-content/uploads/2024/08/Jar-of-Time-Pitch-deck-2024.pdf"
                    },
                    {
                        "text": "World Premiere Announcement",
                        "url": "https://www.instagram.com/p/DH8T6maPTPq"
                    },
                    {
                        "text": "2025, In The Palace - International Film Festival",
                        "url": "https://www.inthepalace.com/en/news/n/22nd-in-the-palace-award-winners"
                    }
                ]
            }
        ]
    },
    {
        "year": "2024",
        "projects": [
            {
                "title": "Hilda Ha. Võrgust väljas",
                "director": "Eva Kübar.",
                "details": "(Documentary, Short, Estonia)",
                "role": "Sound Recordist",
                "links": [
                    {
                        "text": "IMDB",
                        "url": "https://www.imdb.com/title/tt33132331/?ref_=ext_shr_lnk"
                    },
                    {
                        "text": "EFIS",
                        "url": "https://www.efis.ee/en/film/21414"
                    },
                    {
                        "text": "Trailer",
                        "url": "https://www.efis.ee/en/film/21414#gallery-trailers"
                    }
                ]
            },
            {
                "title": "Power of the Voice",
                "director": "Maria Kasesalu.",
                "details": "(TV Mini Series, Estonia).",
                "role": "Sound Supervisor",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt29053739",
                        "text": "IMdb"
                    }
                ]
            },
            {
                "title": "Love Deception in Suite 21",
                "director": "Kelli Andermann.",
                "details": "(Short, Estonia).",
                "role": "Sound Supervisor",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt32498146",
                        "text": "IMdb"
                    }
                ]
            },
            {
                "title": "Madleen",
                "director": "Maria Kasesalu.",
                "details": "(Short Documentary, Short, Estonia).",
                "role": "Sound Supervisor",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt30131891/",
                        "text": "IMdb"
                    }
                ]
            },
            {
                "title": "Meliora",
                "director": "Kristin Hildebrand.",
                "details": "(Short, Estonia).",
                "role": "Sound Supervisor",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt32384134",
                        "text": "IMdb"
                    }
                ]
            },
            {
                "title": "Threads",
                "director": "Michael Dawson.",
                "details": "(Short, Estonia).",
                "role": "Sound Recordist"
            },
            {
                "title": "Am I Ukrainian Enough?",
                "director": "Kateryna Hantseva.",
                "details": "(Documentary, Short, Estonia, Ukraine)",
                "role": "Sound Designer",
                "note": "Winner, Best Documentary, BOB 2025"
            },
            {
                "title": "Pwaa: Unspeakable things in the Belly",
                "director": "Ujjwala Maharjan.",
                "details": "(Musical Poetry, Nepal).",
                "role": "Sound Designer",
                "links": [
                    {
                        "url": "https://youtu.be/mqVEz-q428c?si=OfVafe8ur0Os_QK1",
                        "text": "Full Video"
                    }
                ]
            },
            {
                "title": "Dead Dreaming",
                "director": "Kateryna Hantseva.",
                "details": "(Docu-Dance Short, Ukraine, Estonia).",
                "role": "Sound Designer",
                "links": [
                    {
                        "url": "https://filmfreeway.com/Deaddreaming",
                        "text": "Teaser"
                    }
                ]
            },
            {
                "title": "The Garden Beneath",
                "director": "Fadi Saghbiny.",
                "details": "(Dance Film, Short, Estonia).",
                "role": "Sound Designer",
                "links": [
                    {
                        "url": "https://vimeo.com/950529463",
                        "text": "Full Video"
                    }
                ]
            },
            {
                "title": "Mardazma",
                "director": "Masoud Soheili.",
                "details": "(Fiction, Short, Iran)",
                "role": "Sound Designer",
                "note": "Best Short Film Award - San Lorenzo Film Festival 2025",
                "links": [
                    {
                        "text": "IMdb",
                        "url": "https://www.imdb.com/title/tt36256052"
                    }
                ]
            },
            {
                "title": "Going Nowhere",
                "director": "Daniel Angarita.",
                "details": "(Short, Hungary, Estonia).",
                "role": "Sound Designer"
            },
            {
                "title": "As Day Goes By",
                "director": "Ngima Gelu Lama.",
                "details": "(Short Documentary, Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt32097670",
                        "text": "IMdb"
                    }
                ]
            }
        ]
    },
    {
        "year": "2023",
        "projects": [
            {
                "title": "Tea On Mars",
                "director": "Malu Lins.",
                "details": "(Infomercial, Portugal).",
                "role": "Sound Designer",
                "links": [
                    {
                        "url": "https://www.instagram.com/reel/DCESucgIgyp",
                        "text": "New Born"
                    },
                    {
                        "url": "https://www.instagram.com/reel/DCEcQtVo-Nt",
                        "text": "Finding Our Way"
                    },
                    {
                        "url": "https://www.instagram.com/reel/DCEonx9oIrM",
                        "text": "We are Here We are Alive"
                    }
                ]
            },
            {
                "title": "5 Minutes with Clémentina",
                "director": "Pedro Hasrouny.",
                "details": "(Short, Portugal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt33254433/fullcredits/",
                        "text": "IMdb"
                    },
                    {
                        "url": "https://www.themoviedb.org/movie/1248613-5-minutes-with-clementina/cast",
                        "text": "TMDB"
                    },
                    {
                        "url": "https://www.kinoeyes.eu/collaboration-between-alumni/936-clementina",
                        "text": "Kino Eyes"
                    }
                ]
            },
            {
                "title": "Low Budget Heist",
                "director": "Mahdi Kandyl.",
                "details": "(Feature, Lebanon).",
                "role": "Sound Designer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt32289076",
                        "text": "IMdb"
                    },
                    {
                        "url": "https://youtu.be/IHgfGaOUZzQ",
                        "text": "Trailer"
                    }
                ]
            },
            {
                "title": "It's Like Summer",
                "director": "Baran Ismail Ulas.",
                "details": "(Documentary, Short, Estonia).",
                "role": "Sound Designer",
                "links": [
                    {
                        "url": "https://www.themoviedb.org/movie/1367464-nagu-oleks-suvi-aga-tegelikult-on-suva",
                        "text": "TMDB"
                    },
                    {
                        "url": "https://ljmumashortfilmfestival.org/its-like-summer-but-in-fact-its-random/",
                        "text": "LJMU Festival"
                    }
                ]
            },
            {
                "title": "1000",
                "director": "Nevena Semova.",
                "details": "(Short, Estonia).",
                "role": "Sound Designer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt22267566/",
                        "text": "IMdb"
                    },
                    {
                        "url": "https://youtu.be/TaBO9I6V6H0",
                        "text": "Trailer"
                    }
                ]
            },
            {
                "title": "Ukrainer",
                "director": "Mykola Nosok.",
                "details": "(Documentary, Poland, Ukraine).",
                "role": "Sound Designer"
            },
            {
                "title": "Kim Ki.doc",
                "director": "Artur Veeber.",
                "details": "(Documentary, Short, Estonia).",
                "role": "Sound Designer"
            }
        ]
    },
    {
        "year": "2022",
        "projects": [
            {
                "title": "Into Oblivion",
                "director": "Johanna Alvin.",
                "details": "(Fiction, Short, Estonia)",
                "role": "Sound Recordist",
                "links": [
                    {
                        "text": "EFIS",
                        "url": "https://www.efis.ee/en/film/21484"
                    }
                ]
            },
            {
                "title": "Tehnik",
                "director": "Karl Koppelmaa.",
                "details": "(Fiction, Short, Estonia)",
                "role": "Sound Recordist",
                "links": [
                    {
                        "text": "EFIS",
                        "url": "https://www.efis.ee/en/film/20969"
                    }
                ]
            },
            {
                "title": "Days Without",
                "director": "Ivar Erik Yeoman.",
                "details": "(Fiction, Short, Estonia)",
                "role": "Foleys",
                "note": "Best Film award, BOB Film Festival, Tallinn, Estonia",
                "links": [
                    {
                        "text": "EFIS",
                        "url": "https://www.efis.ee/en/film/20740"
                    }
                ]
            },
            {
                "title": "Golden Shower",
                "director": "Stella Carneiro.",
                "details": "(Short, Portugal).",
                "role": "Boom Operator",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt32226917",
                        "text": "IMdb"
                    }
                ]
            },
            {
                "title": "Separation.",
                "director": "Nawa Shrestha.",
                "details": "(Short Portrait, Portugal).",
                "role": "Sound Designer"
            },
            {
                "title": "Kõne Taevast (Call of God)",
                "director": "Kim Ki-Duk.",
                "details": "(Feature, Kazakhstan).",
                "role": "Sound Designer",
                "links": [
                    {
                        "url": "https://m.imdb.com/title/tt21375588/",
                        "text": "IMDb"
                    }
                ]
            },
            {
                "title": "Sõiduõpetaja.",
                "director": "Arbo Tammiksaar.",
                "details": "(Fiction, Short, Estonia)",
                "role": "Sound Recordist"
            },
            {
                "title": "Sassis TV Show",
                "director": "Rain Tolk.",
                "details": "(Fiction, Short, Estonia)",
                "role": "Sound Recordist"
            },
            {
                "title": "Oh Hi",
                "director": "Lou-Andréa Fière.",
                "details": "(Fiction, Short, Estonia)",
                "role": "Sound Recordist"
            },
            {
                "title": "1000",
                "director": "Nevena Semova.",
                "details": "(Fiction, Short, Estonia)",
                "role": "Sound Recordist",
                "links": [
                    {
                        "text": "IMdb",
                        "url": "https://www.imdb.com/title/tt22267566/"
                    },
                    {
                        "text": "Trailer",
                        "url": "https://youtu.be/TaBO9I6V6H0"
                    }
                ]
            },
            {
                "title": "Kodalane",
                "director": "Alex Tervinsky.",
                "details": "(Documentary, Short, Estonia)",
                "role": "Sound Recordist"
            },
            {
                "title": "Strawberry Shake",
                "director": "Lou-Andréa Fière.",
                "details": "(Fiction, Short, Estonia)",
                "role": "Additional Mixing Engineer, Foleys"
            },
            {
                "title": "Hunger",
                "director": "Liise Marie.",
                "details": "(Dance Film, Short, Estonia)",
                "role": "Sound Recordist, Sounddesign, Film Mix",
                "note": "(Best Student Film, Exeter Dance International Film Festival)",
                "links": [
                    {
                        "text": "IMdb",
                        "url": "https://www.imdb.com/title/tt22190752/"
                    },
                    {
                        "text": "Full Video",
                        "url": "https://vimeo.com/728201039/8da3e214d9"
                    }
                ]
            },
            {
                "title": "Padaste",
                "director": "Katariina Rahumägi.",
                "details": "(Fiction, Short, Estonia)",
                "role": "ADR recordist, Foleys",
                "links": [
                    {
                        "text": "IMdb",
                        "url": "https://www.imdb.com/title/tt21381948/"
                    }
                ]
            },
            {
                "title": "Võõrad (Unfamiliars)",
                "director": "Lauri Elstelä.",
                "details": "(Short, Estonia).",
                "role": "Production Sound, Sounddesign, Film Mix",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt18952654/",
                        "text": "IMDb"
                    }
                ],
                "note": "Instagram: https://www.instagram.com/empty.house.shortfilm"
            },
            {
                "title": "Constellation",
                "director": "Ana Falcon.",
                "details": "(Short, Estonia).",
                "role": "Production Sound Recordist, Sound Designer, Theatre Sound Specialist",
                "links": [
                    {
                        "url": "https://www.kinoeyes.eu/collaboration-between-alumni/820-constellations",
                        "text": "Kino Eyes"
                    }
                ]
            },
            {
                "title": "Cold Bodies",
                "director": "Johanna Alvin.",
                "details": "(Short, Estonia).",
                "role": "Production Sound Recordist, Boom Op"
            },
            {
                "title": "The Strange Disappearance of Comrade Kuliakov",
                "director": "Lucas Abrahão.",
                "details": "(Short, Estonia).",
                "role": "Additional ADR recordist"
            },
            {
                "title": "CPS Above and Beyond",
                "director": "Samir Jung Thapa.",
                "details": "(Documentary, Short, Nepal, USA).",
                "role": "Dialogue Editor, Re-recording Mixer"
            },
            {
                "title": "Sana y Salva",
                "director": "Laura Garcia.",
                "details": "(Short, Mexico/Estonia).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://web.archive.org/web/20220519053415/https://istanbulff.com/april-2022/",
                        "text": "BIFF Winner: Best Original Music Golden Award"
                    }
                ]
            }
        ]
    },
    {
        "year": "2021",
        "projects": [
            {
                "title": "Lukus",
                "director": "Umut Vedat.",
                "details": "(Short, Estonia).",
                "role": "Sounddesign, Sound Mixing",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt15227896",
                        "text": "IMDb"
                    }
                ]
            },
            {
                "title": "Poplar Tree",
                "director": "Manoj Kumar Pant.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.themoviedb.org/movie/1203900-the-poplar-trees",
                        "text": "TMDB"
                    }
                ]
            },
            {
                "title": "The Silence of Banana Trees",
                "director": "Eneos Çarka.",
                "details": "(Documentary, Short, Hungary).",
                "role": "Sound Design, Film Mix",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt29490677/",
                        "text": "IMdb"
                    },
                    {
                        "url": "https://www.justwatch.com/us/movie/the-silence-of-the-banana-trees",
                        "text": "JustWatch"
                    }
                ]
            },
            {
                "title": "Momentum",
                "director": "Felix Cognard.",
                "details": "(Dance Film, Estonia).",
                "role": "Composer, Sounddesign, Film Mix"
            },
            {
                "title": "Kathmandu Monsoon",
                "director": "Ngima Gelu Lama.",
                "details": "(Documentary, Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt16868432/",
                        "text": "IMDb"
                    }
                ]
            },
            {
                "title": "Chiso Manche",
                "director": "Dipendra K. Khanal.",
                "details": "(Feature, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtu.be/U0I17GLoCE4",
                        "text": "Teaser"
                    }
                ]
            },
            {
                "title": "Two Piles of Pillows",
                "director": "Pratik Singh.",
                "details": "(Short, Nepal).",
                "role": "Composer, Sounddesign, Film Mix",
                "links": [
                    {
                        "url": "https://youtu.be/do860xJahzA",
                        "text": "Full Video"
                    }
                ]
            },
            {
                "title": "Honesty Plea",
                "director": "Ana Falcon.",
                "details": "(Short, Estonia.).",
                "role": "Production sound, Composer, Film Mix"
            },
            {
                "title": "The Bet",
                "director": "Maroof Butt.",
                "details": "(Short, Pakistan).",
                "role": "Sounddesign, Composer, Mixing"
            },
            {
                "title": "Leidsin \"Found You\"",
                "director": "Ragne Mandri.",
                "details": "(Fiction, Short, Estonia)",
                "role": "Boom operator, Foleys"
            },
            {
                "title": "Mentes Paralelas",
                "director": "Carlotta Sempre.",
                "details": "(Fashion Short, Portugal).",
                "role": "Sounddesign, Composer, Film Mix"
            },
            {
                "title": "Bolota - Cria",
                "director": "Carlotta Sempre.",
                "details": "(Fashion Short, Portugal).",
                "role": "Sounddesign, Composer, Film Mix",
                "links": [
                    {
                        "url": "https://www.instagram.com/tv/CM2yoSPHeOn",
                        "text": "Video"
                    }
                ]
            },
            {
                "title": "Bolota - Cato",
                "director": "Carlotta Sempre.",
                "details": "(Fashion Short, Portugal).",
                "role": "Sounddesign, Composer, Film Mix",
                "links": [
                    {
                        "url": "https://www.instagram.com/tv/CMiOIT_n23X",
                        "text": "Video"
                    }
                ]
            },
            {
                "title": "Bolota - Coraçao",
                "director": "Carlotta Sempre.",
                "details": "(Fashion Short, Portugal).",
                "role": "Sounddesign, Composer, Film Mix",
                "links": [
                    {
                        "url": "https://www.instagram.com/tv/CMQPhfCnKi-",
                        "text": "Video"
                    }
                ]
            },
            {
                "title": "Sink Away",
                "director": "Felix Cognard.",
                "details": "(Short, Portugal).",
                "role": "Sound Recordist, Boom Operator",
                "links": [
                    {
                        "url": "https://youtu.be/EcxBS2ECkMM",
                        "text": "Trailer"
                    }
                ],
                "note": "IMDb: https://www.imdb.com/title/tt15711340/"
            },
            {
                "title": "Meu Gira Sol",
                "director": "Rebecca Murbach.",
                "details": "(Short, Portugal).",
                "role": "Composer, Film Mix",
                "links": [
                    {
                        "url": "https://youtu.be/--UaBp7gKR0",
                        "text": "Video"
                    }
                ]
            },
            {
                "title": "Rua Da Solidão",
                "director": "Lou-Andréa Fière.",
                "details": "(Short, Portugal).",
                "role": "Production sound, Sound Designer, Composer, Film Mix",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt18951274",
                        "text": "IMdb"
                    }
                ]
            },
            {
                "title": "Adrishya Satta",
                "director": "PushpaSangam.",
                "details": "(Music Album, Nepal).",
                "role": "Composing, Recording, Mixing",
                "links": [
                    {
                        "url": "https://youtu.be/0_Mc5n8un6k",
                        "text": "Full Album"
                    }
                ]
            }
        ]
    },
    {
        "year": "2020",
        "projects": [
            {
                "title": "O Que Vemos",
                "director": "Nikola Vucinic.",
                "details": "(Short, Portugal).",
                "role": "Production sound, Boom op"
            },
            {
                "title": "All Nighter “Noitada”",
                "director": "Lauri Elstelä.",
                "details": "(Short, Portugal).",
                "role": "Production sound, Sound Designer, Composer, Film Mix.",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt21228166/",
                        "text": "IMDb"
                    }
                ]
            },
            {
                "title": "The Red Grave",
                "director": "Umesh Ghorasaini.",
                "details": "(Short, Nepal).",
                "role": "Composer"
            }
        ]
    },
    {
        "year": "2019",
        "projects": [
            {
                "title": "Learning to Fly",
                "director": "Katia Savitri.",
                "details": "(Poetry Video, Nepal, USA).",
                "role": "Video Edit, Composer, Sound Mixing",
                "links": [
                    {
                        "url": "https://youtu.be/TtIANSepYkU",
                        "text": "Video"
                    }
                ]
            },
            {
                "title": "Shambhala",
                "director": "Zero’th Studios Nepal.",
                "details": "(Short, Nepal).",
                "role": "Video Editor, Sound Designer, Composer",
                "links": [
                    {
                        "url": "https://youtube.com/playlist?list=PLqy52n2l1Sy5PdvahWiI5rXG8RSy4plG0",
                        "text": "Video Playlist"
                    }
                ]
            },
            {
                "title": "Kuhiro Pariko Sahar",
                "director": "Pasang Dawa Sherpa.",
                "details": "(Trailer, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Aama",
                "director": "Dipendra K. Khanal.",
                "details": "(Feature, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt12320684",
                        "text": "IMDb"
                    },
                    {
                        "url": "https://youtu.be/jC8qrOZnEew",
                        "text": "Full Movie"
                    }
                ]
            },
            {
                "title": "Kawadiwala",
                "director": "Tejendra Serchan.",
                "details": "(Short, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Mugu Documentary",
                "director": "Samir Jung Thapa.",
                "details": "(Documentary, Nepal).",
                "role": "Composer"
            },
            {
                "title": "CPS SkyDive",
                "director": "Samir Jung Thapa.",
                "details": "(Documentary, USA, Nepal).",
                "role": "Composer, Sound Mixing",
                "links": [
                    {
                        "url": "https://fb.watch/7fCvGaSSt8/",
                        "text": "Video"
                    }
                ]
            },
            {
                "title": "Jagatpur Lodge",
                "director": "Samir Jung Thapa.",
                "details": "(Documentary, Advert, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Ainaa Jhyalko Putali",
                "director": "Sujit Bidari.",
                "details": "(Feature, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt9623736",
                        "text": "IMDb"
                    },
                    {
                        "url": "https://youtu.be/IkIbrVUeA-0",
                        "text": "Trailer"
                    }
                ]
            },
            {
                "title": "Pahal",
                "director": "Samir Jung Thapa.",
                "details": "(Documentary, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Kritimukha",
                "director": "Abinash Bikram Shah.",
                "details": "(Short, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Paaniphoto",
                "director": "Khagendra Lamichhane.",
                "details": "(Feature, Nepal).",
                "role": "Music Research, Field Recording, Composer",
                "links": [
                    {
                        "url": "https://youtu.be/1_-0Wiyp_EY",
                        "text": "Trailer"
                    }
                ]
            },
            {
                "title": "Coffee Documentary",
                "director": "Abhimanyu Dixit.",
                "details": "(Documentary, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Jaari",
                "director": "Upendra Subba.",
                "details": "(Feature, Nepal).",
                "role": "Songs Arrangement"
            },
            {
                "title": "Ama Khando",
                "director": "Dhondoup Gurung.",
                "details": "(Fiction, Feature, Nepal)",
                "role": "Production Sound, Composer",
                "links": [
                    {
                        "text": "IMDb",
                        "url": "https://www.imdb.com/title/tt13647276/"
                    },
                    {
                        "text": "Full Film",
                        "url": "https://youtu.be/oDhS2kvt17w"
                    }
                ]
            }
        ]
    },
    {
        "year": "2018",
        "projects": [
            {
                "title": "Bare Trees in the Mist",
                "director": "Rajan Kathet.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt10923060",
                        "text": "IMDb"
                    },
                    {
                        "url": "https://youtu.be/9Ave5tZ9ig4",
                        "text": "Trailer"
                    }
                ]
            },
            {
                "title": "100 Rupees",
                "director": "TR Gaudel.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt9637170",
                        "text": "IMDb"
                    }
                ]
            },
            {
                "title": "Mahanagar / One Night in Kathmandu",
                "director": "Mohan Rai.",
                "details": "(Feature, Nepal).",
                "role": "Composer.",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt14563990",
                        "text": "IMdb"
                    },
                    {
                        "url": "https://www.brooklynfilmfestival.org/film-detail?fid=2290",
                        "text": "Festival Link"
                    }
                ]
            },
            {
                "title": "Cygnus",
                "director": "República de Luz.",
                "details": "(Short, México/USA).",
                "role": "Sound Design, Composer, Film Mix"
            }
        ]
    },
    {
        "year": "2017",
        "projects": [
            {
                "title": "Dokh",
                "director": "Anup Baral.",
                "details": "(Feature, Nepal).",
                "role": "Composer.",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt6818560",
                        "text": "IMDb"
                    },
                    {
                        "url": "https://youtu.be/bFI04MrPmE8",
                        "text": "Trailer"
                    }
                ],
                "note": "(Released 2022)"
            },
            {
                "title": "Chakkar",
                "director": "Anuska Rauniyar.",
                "details": "(Feature, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt8682244",
                        "text": "IMDb"
                    },
                    {
                        "url": "https://youtu.be/5QeBLSDLXUk",
                        "text": "Full Movie"
                    }
                ]
            },
            {
                "title": "Film Festival Jingle",
                "director": "Nawa Bijaya Shrestha.",
                "details": "(Film Festival Jingle, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Samsung TVC",
                "director": "Keshab Pande.",
                "details": "(Advert, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Mainbatti ko Sikha",
                "director": "Sahara Sharma.",
                "details": "(Short, Nepal).",
                "role": "Composer"
            },
            {
                "title": "White House College",
                "director": "Suresh Simkhada.",
                "details": "(Advert, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Nepal Tourism Board: Naturally Nepal",
                "director": "Suraj Poudel.",
                "details": "(Advert, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://fb.watch/7ElEAfj4Dv/",
                        "text": "Video"
                    }
                ]
            },
            {
                "title": "Erasmus Mundus Stories",
                "director": "Rajan Kathet.",
                "details": "(Documentary, Short, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Saipal College",
                "director": "Amitesh Shah.",
                "details": "(Advert, Nepal).",
                "role": "Composer"
            },
            {
                "title": "From Beans to Cup",
                "director": "Nabin Bhatta.",
                "details": "(Advert, Nepal).",
                "role": "Composer"
            }
        ]
    },
    {
        "year": "2016",
        "projects": [
            {
                "title": "DC Diamonds",
                "director": "Rajin Maharjan.",
                "details": "(Advert, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Ekadeshma Jingle. And Life Goes On",
                "director": "Ekadeshma Jingle.",
                "details": "(Film Festival Jingle, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtu.be/AVvUyoI1KEk",
                        "text": "Video"
                    }
                ]
            },
            {
                "title": "KTM Cocktale",
                "director": "Anuska Rauniyar.",
                "details": "(Feature, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt6440150",
                        "text": "IMDb"
                    },
                    {
                        "url": "https://youtu.be/0TnMwZ68YDU",
                        "text": "Full Movie"
                    }
                ]
            },
            {
                "title": "NIC Asia",
                "director": "Sanjeev Maharjan.",
                "details": "(Advert, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Guddu",
                "director": "Emanuel Bikram Shah.",
                "details": "(Short, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Charity",
                "director": "Ali Rasheed.",
                "details": "(Documentary, Short, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Pahuch",
                "director": "Tsering Sherpa.",
                "details": "(TV Reality Show, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtube.com/playlist?list=PL8tRUA08XEc2Wfjczb2a6t9mXh-xecxGZ",
                        "text": "Series Playlist"
                    }
                ]
            },
            {
                "title": "Ncell – We are Giving More",
                "director": "Keshab Pande.",
                "details": "(Advert, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtu.be/b3w4Azy6Bkw",
                        "text": "Video"
                    }
                ]
            },
            {
                "title": "Ncell – We are Expanding",
                "director": "Keshab Pande.",
                "details": "(Advert, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtu.be/pp6HKXyA9M0",
                        "text": "Video"
                    }
                ]
            },
            {
                "title": "Ncell – We offer Extra",
                "director": "Keshab Pande.",
                "details": "(Advert, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtu.be/4yErNxm0B_I",
                        "text": "Video"
                    }
                ]
            },
            {
                "title": "Lama La",
                "director": "Nischal Poudyal.",
                "details": "(Feature, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtu.be/K4nbSXh95OI",
                        "text": "Trailer"
                    }
                ]
            },
            {
                "title": "Tu",
                "director": "Gambhir Rawal.",
                "details": "(Feature, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Kalo Pothi",
                "director": "Min Bahadur Bham.",
                "details": "(Trailer, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtu.be/wS4C8MQUFds",
                        "text": "Trailer"
                    }
                ]
            },
            {
                "title": "Goodbye Kathmandu",
                "director": "Nabin Subba.",
                "details": "(Feature, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt7870694",
                        "text": "IMDb"
                    }
                ]
            },
            {
                "title": "Phulsiri",
                "director": "Ngima Gelu Lama.",
                "details": "(Feature, Nepal).",
                "role": "Production Sound, Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt5709520",
                        "text": "IMDb"
                    }
                ]
            },
            {
                "title": "Dhyangro",
                "director": "Rajkumar Rai.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtu.be/guTROzW_R34",
                        "text": "Full Movie"
                    }
                ]
            }
        ]
    },
    {
        "year": "2015",
        "projects": [
            {
                "title": "Jagadamba Steel",
                "director": "Keshab Pande.",
                "details": "(Advert, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Bio Compost Fertilizer",
                "director": "Alina Prajapati.",
                "details": "(Advert, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Water by WWF",
                "director": "Samir Jung Thapa.",
                "details": "(Documentary, Short, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Sapana",
                "director": "Jiwan Adhikary.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtu.be/joz_9Tlra-k",
                        "text": "Full Movie"
                    }
                ]
            },
            {
                "title": "Letter to God",
                "director": "Sushil Chettry.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtu.be/8v0kjc3pwkI",
                        "text": "Full Movie"
                    }
                ]
            }
        ]
    },
    {
        "year": "2014",
        "projects": [
            {
                "title": "Butte Jama",
                "director": "Kala Sangroula.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.viddsee.com/video/striped-skirt-butte-jama",
                        "text": "Video"
                    }
                ]
            },
            {
                "title": "Kafal Pakyo",
                "director": "Niranjan Raj Bhetwal.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt4208620",
                        "text": "IMDb"
                    }
                ]
            },
            {
                "title": "Kyar Kyar Pankha",
                "director": "Pasang Dawa Sherpa.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtu.be/bOCohQUXk8M",
                        "text": "Trailer"
                    },
                    {
                        "url": "https://youtu.be/ALJJ-OjFJp4",
                        "text": "Full Movie"
                    }
                ]
            },
            {
                "title": "Ritu",
                "director": "Manoj Adhikari.",
                "details": "(Feature, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtu.be/EOKuN2RFGpo",
                        "text": "Trailer"
                    }
                ]
            },
            {
                "title": "Serdhak",
                "director": "Rajan Kathet.",
                "details": "(Feature, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt3598818",
                        "text": "IMDb"
                    }
                ]
            }
        ]
    },
    {
        "year": "2013",
        "projects": [
            {
                "title": "Panchakanya Jingle",
                "director": "Rajan Kathet.",
                "details": "(Advert, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Feri Euta Kathako Antya Huncha",
                "director": "Kushang Rai.",
                "details": "(Short, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Batuliko Chura",
                "director": "Anup Poudel.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt3213248",
                        "text": "IMDb"
                    },
                    {
                        "url": "https://youtu.be/UGB1CfCrnIY",
                        "text": "Video"
                    }
                ]
            },
            {
                "title": "Sharanam.",
                "director": "Abinash Bikram Shah.",
                "details": "(Short, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Awartan",
                "director": "Santosh Bhattarai.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtu.be/x7MmhNIcDMw",
                        "text": "Full Movie"
                    }
                ]
            },
            {
                "title": "Okhati",
                "director": "Sarun Manandhar.",
                "details": "(Short, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Pratibimbha",
                "director": "Sampada Malla.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt3143526",
                        "text": "IMDb"
                    }
                ]
            },
            {
                "title": "Ekadeshma Short Film Festival. Threads of Stories",
                "director": "Ekadeshma Short Film Festival.",
                "details": "(Jingle for Film Festival, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtu.be/FOngGOUBeAA",
                        "text": "Video"
                    }
                ]
            }
        ]
    },
    {
        "year": "2012",
        "projects": [
            {
                "title": "Akashmik Labh",
                "director": "Govinda Sivakoti.",
                "details": "(Short, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Saas Fere Jasto Lagcha",
                "director": "Santosh Bhattarai.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt2474992",
                        "text": "IMDb"
                    },
                    {
                        "url": "https://youtu.be/nikH7tw5GxA",
                        "text": "Trailer"
                    }
                ]
            },
            {
                "title": "Nagarjuna",
                "director": "Rajan Kathet.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtu.be/NNs39Wg1zEs",
                        "text": "Trailer"
                    }
                ]
            },
            {
                "title": "Shukrakeet",
                "director": "Shahil Shrestha.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtu.be/m1LAAumGLo0",
                        "text": "Trailer"
                    }
                ]
            },
            {
                "title": "Bansulli",
                "director": "Min Bahadur Bham.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt2514384",
                        "text": "IMDb"
                    },
                    {
                        "url": "https://youtu.be/SyEx6Ph7La8",
                        "text": "Trailer"
                    }
                ]
            },
            {
                "title": "Ma Janna",
                "director": "Kshitiz Shrestha.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://youtu.be/8Ys2zW7i50o",
                        "text": "Trailer"
                    }
                ]
            },
            {
                "title": "Garva",
                "director": "Manav Subedi.",
                "details": "(Short, Nepal).",
                "role": "Composer"
            }
        ]
    },
    {
        "year": "2011",
        "projects": [
            {
                "title": "Open Your Eyes",
                "director": "Suraj Poudel.",
                "details": "(Short, Nepal).",
                "role": "Composer"
            },
            {
                "title": "Ma Khushi Chu",
                "director": "Abinash Bikram Shah.",
                "details": "(Short, Nepal).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt2087866",
                        "text": "IMDb"
                    },
                    {
                        "url": "https://youtu.be/S-GH3fP662s",
                        "text": "Trailer"
                    }
                ]
            }
        ]
    },
    {
        "year": "2010",
        "projects": [
            {
                "title": "God’s Cellphone",
                "director": "Ehsaan Kuthu.",
                "details": "(Short, Iran/India).",
                "role": "Composer",
                "links": [
                    {
                        "url": "https://www.imdb.com/title/tt8645030",
                        "text": "IMdb"
                    }
                ]
            }
        ]
    }
];
